import DataTable from "ui/DataTable"
import { getHeaders } from "./headers"
import { useMemo } from "react"
import CustomPagination from "components/common/CustomPagination"
import moment from "moment"
import { Grid } from "antd"
import DataTableResponsive from "ui/DataTableResponsive"
import LoadMoreButton from "components/common/LoadMore"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import { Paragraph } from "ui/Typography"
const { useBreakpoint } = Grid

const TextHistoryTable = ({ data, page, metadata, pageSize, onPageChange, onPageSizeChange, onSortChange, onRowClick, setIsAppend }) => {
  const screens = useBreakpoint()
  const { loading } = useSelector((state) => state.clients.textLogs)

  const isMobile = !screens.md

  const dataSource = useMemo(() => {
    return (
      data?.map((text) => {
        const { id, timestamp, message } = text || {}
        return {
          key: id,
          date_sent: moment(timestamp).format("MM/DD/YY hh:mm A"),
          message: (
            <Paragraph
              ellipsis={{
                rows: 3,
                tooltip: true
              }}
            >
              {message}
            </Paragraph>
          )
        }
      }) || []
    )
  }, [data])

  const textsData = useMemo(() => {
    return data.map((text) => {
      const { id, timestamp, message } = text || {}
      return {
        id,
        "Date Sent": moment(timestamp).format("MM/DD/YY hh:mm A"),
        Message: message
      }
    })
  }, [data])

  const handleMobileRowClick = (data) => {
    onRowClick(data?.id)
  }

  const handleLoadMore = () => {
    onPageChange(page + 1)
    setIsAppend(true)
  }

  const isResultMoreThanPage = useMemo(() => metadata?.total_results > 10, [metadata?.total_results])

  return isMobile ? (
    <>
      <DataTableResponsive data={textsData} onItemClick={handleMobileRowClick} />
      {isResultMoreThanPage && (
        <LoadMoreButton
          currentPage={page}
          totalPages={Math.ceil(metadata.total_results / pageSize)}
          loading={loading}
          onLoadMore={handleLoadMore}
          totalAvailable={metadata.total_results}
        />
      )}
    </>
  ) : (
    <>
      <div className="overflow-auto">
        <DataTable columns={getHeaders()} dataSource={dataSource} pagination={false} onChange={onSortChange} onRowClick={onRowClick} />
      </div>
      {isResultMoreThanPage && (
        <CustomPagination
          metadata={metadata}
          pageSize={pageSize}
          total={metadata?.total_results || 0}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      )}
    </>
  )
}

TextHistoryTable.propTypes = {
  data: PropTypes.array,
  page: PropTypes.number,
  metadata: PropTypes.object,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  onSortChange: PropTypes.func,
  onRowClick: PropTypes.func,
  setIsAppend: PropTypes.func
}

export default TextHistoryTable
